import React from 'react';

/**
 * Pestañas «Movimientos | Monedero» del historial de una ficha.
 *
 * Viven aquí y no en cada modal porque las usan la ficha del socio y la del
 * personal (el personal también tiene saldo: Profile.credit_balance es común a
 * CLIENT/STAFF/OWNER). Antes solo existían en la del socio y el monedero del
 * personal no se podía ver (reporte de Yago, 12-10-2026).
 *
 * Pantallas consumidoras: ficha del socio (ClientDetailModal) y ficha del personal
 * (StaffOwnerDetailModal). Las dos arrancan en Movimientos al abrir el historial.
 */
export const PESTANAS_HISTORIAL = [
  { id: 'movimientos', label: 'Movimientos' },
  { id: 'monedero', label: 'Monedero' },
];

export default function HistorialPestanas({ value, onChange }) {
  return (
    // Botones con aria-pressed (un selector segmentado), no role="tab": un tablist a medias
    // —sin tabpanel ni flechas— promete al lector de pantalla un patrón que no cumple.
    <div className="mb-4 flex gap-1 rounded-xl bg-[var(--wa-card-muted)] p-1 w-fit">
      {PESTANAS_HISTORIAL.map((t) => (
        <button
          key={t.id}
          type="button"
          aria-pressed={value === t.id}
          onClick={() => onChange(t.id)}
          className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-colors ${
            value === t.id
              ? 'bg-white text-[var(--wa-foreground)] shadow-sm'
              : 'text-[var(--wa-muted-foreground)] hover:text-[var(--wa-foreground)]'
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
